// extracted by mini-css-extract-plugin
export var actionIcon = "FileDownload-module--actionIcon--95Bj7";
export var link = "FileDownload-module--link--aNjhE";
export var title = "FileDownload-module--title--VWGuB";